
import React from 'react';

const TrustBar: React.FC = () => {
  // Representative placeholder names for an enterprise consulting firm
  const partners = ["FORBES_500", "SaaS_GLOBAL", "CHICAGO_FINTECH", "CLOUD_INFRA", "NEO_LOGISTICS", "HEALTH_CORE", "VET_SYSTEMS", "GRID_NETWORKS"];

  return (
    <div className="bg-white border-y border-slate-100 py-12 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mb-6">
        <div className="mono text-[8px] text-slate-400 font-bold uppercase tracking-[0.5em] text-center">// Strategic Ecosystem Integration</div>
      </div>
      <div className="flex animate-marquee whitespace-nowrap">
        {[...partners, ...partners].map((name, i) => (
          <div key={i} className="mx-12 flex items-center space-x-2 grayscale opacity-30 hover:opacity-100 hover:grayscale-0 transition-all cursor-default group">
            <div className="w-8 h-8 bg-slate-900 flex items-center justify-center rounded-sm">
               <div className="w-3 h-3 border border-white opacity-40"></div>
            </div>
            <span className="mono text-sm font-bold text-slate-900 tracking-tighter">{name}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TrustBar;
